import { CreditProduct } from '@/types/card';

export const BUSINESS_CREDIT_CARD_PRODUCTS = [
    CreditProduct.EIKA_ANSATT,
    CreditProduct.LOKALBANK_ANSATT,
    CreditProduct.EIKA_ANSATT_DIREKTE,
    CreditProduct.AGRICARD_ANSATT,
];

export const AGRICARD_CREDIT_CARD_PRODUCTS = [
    CreditProduct.AGRICARD_PRIVAT,
    CreditProduct.AGRICARD_ANSATT,
    CreditProduct.AGRICARD_BEDRIFT,
    CreditProduct.AGRICARD_DIGITAL_REISEKORT,
];

export const LBS_CREDIT_CARD_PRODUCTS = [
    CreditProduct.LOKALBANK_PRIVAT,
    CreditProduct.LOKALBANK_ANSATT,
    CreditProduct.LOKALBANK_BEDRIFT,
];

export const NAF_CREDIT_CARD_PRODUCTS = [CreditProduct.NAF_XTRA];
